export function DSAnalyticsScript({ gtagId = 'G-LLCH0NYZ61' }) {
  // useEffect(() => {
  //   if (!gtagId) return;

  //   const loadGA4 = () => {
  //     // 1. Load the gtag.js library
  //     const gtagScript = document.createElement('script');
  //     gtagScript.src = `https://www.googletagmanager.com/gtag/js?id=${gtagId}`;
  //     gtagScript.async = true;
  //     document.head.appendChild(gtagScript);

  //     // 2. Initialize gtag
  //     const initScript = document.createElement('script');
  //     initScript.innerHTML = `
  //       window.dataLayer = window.dataLayer || [];
  //       function gtag(){dataLayer.push(arguments);}
  //       gtag('js', new Date());
  //       gtag('config', '${gtagId}');
  //     `;
  //     document.head.appendChild(initScript);
  //   };

  //   if (document.readyState === 'loading') {
  //     document.addEventListener('DOMContentLoaded', loadGA4);
  //   } else {
  //     loadGA4();
  //   }

  //   return () => {
  //     document.removeEventListener('DOMContentLoaded', loadGA4);
  //   };
  // }, [gtagId]);

  return (
    <>
      <script async src={`https://www.googletagmanager.com/gtag/js?id=${gtagId}`} />
      <script
        dangerouslySetInnerHTML={{
          __html: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', ${gtagId});`,
        }}
      />
    </>
  );
}
